import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useRateConversationPageStyles = makeStyles({
    root: {
        ...shorthands.padding('1rem', tokens.spacingHorizontalXXXL),
        alignSelf: 'flex-start',
        justifyItems: 'start',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
        maxHeight: '70vh',
        '& > :not(:last-child)': {
            marginBottom: '1.25rem',
        },
    },
    formField: {
        display: 'flex',
        flexDirection: 'column',
        '& > label': {
            marginBottom: tokens.spacingVerticalMNudge,
        }
    },
    textArea: {
        resize: 'vertical',
    },
    helperText: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        marginTop: '4px',
    },
    actions: {
        marginTop: 'auto',
        alignSelf: 'end',
    },
});
